export default class BaseObject {
  write (repository, resource, { payload }) {
    repository.update(resource.path, payload)
  }

  remove (vm, path) {
    // TODO
  }
}